/* ===================================================================
   LED-BOX 2026 — calculator de lumeni si necesar de corpuri.

   Metoda (simplificata, dar declarata pe pagina ca sa fie verificabila):

       lumeni necesari = suprafata x nivel de iluminare / factor de utilizare

   Nivelul de iluminare (lx) vine din setarile secTiunii, pe tip de incapere.
   Factorul de utilizare acopera pierderile: cu cat tavanul e mai inalt, cu
   atat ajunge mai putina lumina pe planul util, deci factorul scade.

   Nu e un calcul luminotehnic profesional: acela cere reflectanta peretilor,
   pozitia corpurilor si curbele fotometrice. E o estimare buna pentru un
   client care vrea sa stie "cate bucati imi trebuie", si asa e prezentata.

   Recomandarile se fac din assets/lb-calc-produse.json, generat din catalog:
   doar produse active, in stoc, cu lumeni cunoscuti. Lanternele si produsele
   auto sunt excluse din start — nu se folosesc la iluminat de incapere.
   =================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-lb-calc]');
  if (!root) return;

  var config = JSON.parse(root.getAttribute('data-lb-calc') || '{}');
  var baza = null;          // se incarca la prima calculare
  var seIncarca = false;

  var el = {
    incapere: root.querySelector('[data-calc-incapere]'),
    lungime: root.querySelector('[data-calc-lungime]'),
    latime: root.querySelector('[data-calc-latime]'),
    inaltime: root.querySelector('[data-calc-inaltime]'),
    buton: root.querySelector('[data-calc-buton]'),
    rezultat: root.querySelector('[data-calc-rezultat]'),
    eroare: root.querySelector('[data-calc-eroare]')
  };

  function factorUtilizare(h) {
    // Cu cat corpul e mai sus, cu atat mai putina lumina ajunge jos.
    if (h <= 2.7) return 0.8;
    if (h <= 3.5) return 0.7;
    if (h <= 5) return 0.6;
    return 0.5;
  }

  function nr(v, implicit) {
    var x = parseFloat(String(v).replace(',', '.'));
    return isFinite(x) && x > 0 ? x : implicit;
  }

  function formatLm(n) {
    return n.toLocaleString('ro-RO');
  }

  function incarcaBaza() {
    if (baza) return Promise.resolve(baza);
    if (seIncarca) return seIncarca;
    seIncarca = fetch(root.dataset.lbCalcSursa)
      .then(function (r) {
        if (!r.ok) throw new Error('nu pot incarca produsele');
        return r.json();
      })
      .then(function (d) { baza = d; return d; });
    return seIncarca;
  }

  /* Pretul nu e tinut in fisierul de produse: s-ar invechi. Il luam live,
     doar pentru cele cateva produse afisate. */
  function pret(handle) {
    return fetch('/products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p) return null;
        return { pret: p.price, disponibil: p.available };
      })
      .catch(function () { return null; });
  }

  /* Becurile nu sunt o solutie de iluminat in sine: au nevoie de un corp.
     Calculatorul recomanda corpuri, nu surse de schimb. */
  var TIP_EXCLUS = /^becuri/i;

  /* Doua variante de culoare ale aceluiasi model au titluri aproape identice
     si ar ocupa doua locuri din cele sase. Le consideram acelasi produs. */
  function cheieModel(titlu) {
    return titlu.toLowerCase()
      .replace(/[ăâ]/g, 'a').replace(/[îi]/g, 'i').replace(/[șş]/g, 's').replace(/[țţ]/g, 't')
      .replace(/\b(alb|alba|negru|neagra|auriu|argintiu|gri|crom|bronz|maro)\b/g, '')
      .replace(/[^a-z0-9]+/g, ' ').trim().slice(0, 34);
  }

  /* Lampile stradale si de stalp apar in zona halelor pentru ca sunt corpuri
     de mare putere, dar sunt facute pentru exterior. Le scoatem din incaperi. */
  var INTERIOR = 'ibgh';
  var DOAR_EXTERIOR = /stradal|stalp|stâlp|proiector solar|lampa solara|lampă solară/i;

  function alegeProduse(necesar, zona) {
    var inauntru = INTERIOR.indexOf(zona) !== -1;
    var lista = baza.produse.filter(function (p) {
      if (TIP_EXCLUS.test(p.pt)) return false;
      if (inauntru && DOAR_EXTERIOR.test(p.pt + ' ' + p.t)) return false;
      return !zona || p.z.indexOf(zona) !== -1;
    });
    if (lista.length < 6) {
      lista = baza.produse.filter(function (p) { return !TIP_EXCLUS.test(p.pt); });
    }

    var optiuni = [];
    lista.forEach(function (p) {
      var n = Math.ceil(necesar / p.lm);
      // Sub 1 bucata n-are sens, peste 12 devine nepractic pentru o camera.
      if (n < 1 || n > 12) return;
      var livrat = n * p.lm;
      // Penalizam depasirea mare si numarul exagerat de corpuri.
      var scor = (livrat - necesar) / necesar + (n > 8 ? 0.5 : 0);
      optiuni.push({ p: p, n: n, livrat: livrat, scor: scor });
    });

    optiuni.sort(function (a, b) { return a.scor - b.scor; });

    // Diversitate: maximum doua propuneri din acelasi tip de produs si o
    // singura varianta de culoare din acelasi model.
    var pePtip = {}, modele = {}, alese = [];
    for (var i = 0; i < optiuni.length && alese.length < 6; i++) {
      var t = optiuni[i].p.pt || '-';
      var m = cheieModel(optiuni[i].p.t);
      if (modele[m]) continue;
      if ((pePtip[t] || 0) >= 2) continue;
      pePtip[t] = (pePtip[t] || 0) + 1;
      modele[m] = true;
      alese.push(optiuni[i]);
    }
    return alese;
  }

  function cardProdus(o) {
    var p = o.p;
    var img = p.i ? baza.prefix + p.i : '';
    return '' +
      '<a class="lb-calc__card" href="/products/' + p.h + '">' +
        /* Fara loading="lazy": imaginile sunt injectate dupa randare si browserul
           amana descarcarea la nesfarsit. Sunt doar sase, imediat vizibile. */
        (img ? '<span class="lb-calc__thumb"><img src="' + img + '" alt="" width="64" height="64" decoding="async"></span>' : '') +
        '<span class="lb-calc__card-body">' +
          '<span class="lb-calc__card-title">' + p.t + '</span>' +
          '<span class="lb-calc__card-spec">' + formatLm(p.lm) + ' lm/buc · ' + (p.pt || '') + '</span>' +
          '<span class="lb-calc__card-qty"><strong>' + o.n + ' ' + (o.n === 1 ? 'bucată' : 'bucăți') + '</strong>' +
            ' = ' + formatLm(o.livrat) + ' lm</span>' +
          '<span class="lb-calc__card-price" data-pret="' + p.h + '"></span>' +
        '</span>' +
      '</a>';
  }

  function calculeaza() {
    var cheie = el.incapere.value;
    var incapere = config.incaperi[cheie];
    var L = nr(el.lungime.value, 0);
    var l = nr(el.latime.value, 0);
    var h = nr(el.inaltime.value, 2.6);

    el.eroare.hidden = true;
    if (!L || !l) {
      el.eroare.textContent = 'Completează lungimea și lățimea camerei.';
      el.eroare.hidden = false;
      return;
    }
    if (L > 200 || l > 200) {
      el.eroare.textContent = 'Verifică dimensiunile: par introduse în centimetri, nu în metri.';
      el.eroare.hidden = false;
      return;
    }

    var arie = L * l;
    var fu = factorUtilizare(h);
    var necesar = Math.round(arie * incapere.lux / fu);

    el.rezultat.innerHTML =
      '<div class="lb-calc__total">' +
        '<span class="lb-calc__total-label">Ai nevoie de aproximativ</span>' +
        '<span class="lb-calc__total-val">' + formatLm(necesar) + ' lumeni</span>' +
        '<span class="lb-calc__total-sub">pentru ' + arie.toFixed(1).replace('.', ',') + ' m² de ' +
          incapere.nume.toLowerCase() + '</span>' +
      '</div>' +
      '<details class="lb-calc__math"><summary>Cum am calculat</summary>' +
        '<p>' + L.toString().replace('.', ',') + ' m × ' + l.toString().replace('.', ',') + ' m = <strong>' +
        arie.toFixed(1).replace('.', ',') + ' m²</strong>, înmulțit cu <strong>' + incapere.lux +
        ' lucși</strong> recomandați pentru ' + incapere.nume.toLowerCase() +
        ', împărțit la factorul de utilizare <strong>' + fu.toString().replace('.', ',') +
        '</strong> pentru o înălțime de ' + h.toString().replace('.', ',') + ' m.</p>' +
        '<p>Factorul acoperă lumina pierdută spre pereți și tavan. Cu cât tavanul e mai înalt, cu atât mai puțină lumină ajunge pe planul util.</p>' +
      '</details>' +
      '<div class="lb-calc__loading">Caut produse potrivite…</div>';

    incarcaBaza().then(function () {
      var alese = alegeProduse(necesar, incapere.zona);
      if (!alese.length) {
        root.querySelector('.lb-calc__loading').textContent =
          'Nu am găsit o combinație potrivită în stoc. Scrie-ne și îți facem noi calculul.';
        return;
      }
      var html = '<h3 class="lb-calc__rec-title">Produse care acoperă necesarul</h3>' +
                 '<div class="lb-calc__grid">' + alese.map(cardProdus).join('') + '</div>' +
                 '<p class="lb-calc__nota">Estimare orientativă. Pentru proiecte tehnice sau spații cu cerințe speciale, scrie-ne și facem calculul detaliat.</p>';
      root.querySelector('.lb-calc__loading').outerHTML = html;

      // Preturile, live, doar pentru produsele afisate.
      alese.forEach(function (o) {
        pret(o.p.h).then(function (info) {
          var box = root.querySelector('[data-pret="' + o.p.h + '"]');
          if (!box || !info) return;
          var unitar = (info.pret / 100);
          var total = unitar * o.n;
          box.innerHTML = '<strong>' + total.toLocaleString('ro-RO', { minimumFractionDigits: 2 }) + ' lei</strong>' +
            (o.n > 1 ? ' <span>(' + unitar.toLocaleString('ro-RO', { minimumFractionDigits: 2 }) + ' lei × ' + o.n + ')</span>' : '');
        });
      });
    }).catch(function () {
      var l = root.querySelector('.lb-calc__loading');
      if (l) l.textContent = 'Nu am putut încărca lista de produse. Reîncarcă pagina.';
    });
  }

  el.buton.addEventListener('click', calculeaza);
  root.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.tagName === 'INPUT') { e.preventDefault(); calculeaza(); }
  });
})();
